export const HASH_SECRET = 'oomsecret'
